"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestRoleStatsMulti = void 0;
const util_1 = require("@app/util");
const apollo_1 = require("@app/util/apollo");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const moment_1 = __importDefault(require("moment"));
const roleStatsMultiQuery = (0, graphql_tag_1.default) `
  query RoleStatsMultiQuery(
    $id: ID!
    $referenceDate: Datetime
    $userIds: [ID!]
    $splitByContractTypes: Boolean
    $splitByPositions: Boolean
  ) {
    workspace(id: $id) {
      members(userIds: $userIds) {
        roles {
          userId
          vacation {
            contractType
            amount
            unit
          }
          stats(
            referenceDate: $referenceDate
            splitByContractTypes: $splitByContractTypes
            splitByPositions: $splitByPositions
          ) {
            monthPlannedMinutes
            monthPlannedMinutesByContract {
              contractType
              minutes
            }
            monthPlannedMinutesByPosition {
              positionId
              minutes
            }
            monthOverTimeMinutes
            monthOverTimeMinutesByPosition {
              positionId
              minutes
            }
            monthOverTimeMinutesByContract {
              contractType
              minutes
            }

            monthContractMinutes
            monthContractMinutesByContract {
              contractType
              minutes
            }
            balancingPeriodPlannedMinutes
            balancingPeriodPlannedMinutesByContract {
              contractType
              minutes
            }
            balancingPeriodPlannedMinutesByPosition {
              positionId
              minutes
            }
            balancingPeriodContractMinutes
            balancingPeriodContractMinutesByContract {
              contractType
              minutes
            }
            balancingPeriodOverTimeMinutes

            yearVacationMinutes
            yearVacationRemainingMinutes
            yearVacationDays
            yearVacationRemainingDays
          }
        }
      }
    }
  }
`;
const requestRoleStatsMulti = async (variables) => {
    if ((0, util_1.isValue)(variables) &&
        (0, util_1.isValue)(variables.referenceDate) &&
        (variables?.referenceDate?.toString()?.match(/\d{4}-\d{2}$/)?.length ?? 0) > 0) {
        variables.referenceDate = (0, moment_1.default)(variables.referenceDate, 'YYYY-MM')
            .endOf('month')
            .format('YYYY-MM-DD');
    }
    const { data, errors } = await (0, apollo_1.query)(roleStatsMultiQuery, {
        variables,
    });
    // processErrors(errors)
    const _data = data?.workspace;
    return Object.assign(_data ?? {}, { error: errors?.[0] });
};
exports.requestRoleStatsMulti = requestRoleStatsMulti;
exports.default = exports.requestRoleStatsMulti;
